export enum ProfitType {
  INCREASE = 'increase',
  DECREASE = 'decrease'
}